module.exports = __webpack_public_path__ + "img/orgDetail_3_small.482d9bea.png";